import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'

const citizenSex = enumerated({
  male: 'Masculino',
  female: 'Feminino',
})

export const operatorObject = z.object({
  id: z.string().uuid(),
  code: z.number().int().positive(),
  citizenId: z.string().uuid(),
  fullName: z.string().nullish(),
  nickname: z.string().nullish(),
  socialName: z.string().nullish(),
  sex: citizenSex.nullish(),
  cpf: z.string().nullish(),
  whatsapp: z.string().nullish(),
  alternatePhone: z.string().nullish(),
  cns: z.string().nullish(),
  originalId: z.string().nullish(),
  dataSourceId: z.number().int().nullish(),
  latitude: z.number().nullish(),
  longitude: z.number().nullish(),
  fullAddress: z.string().nullish(),
  complement: z.string().nullish(),
  sourceFilter: z.string().nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  inactivatedAt: dateOrIsoString().nullish(),
})

export const operatorCreateInputObject = z.object({
  id: z.string().uuid().nullish(),
  citizenId: z.string().uuid(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
})

export const operatorUpdateInputObject = z.object({
  id: z.string().uuid(),
  citizenId: z.string().uuid().optional(),
  inactivatedAt: dateOrIsoString().nullable().optional(),
  updatedAt: dateOrIsoString().nullish(),
})

export type OperatorType = z.infer<typeof operatorObject>
